import ForkStepEdge from "./ForkStepEdge";
import StepEdge from "./StepEdge";

const edgeTypes = {
  step_edge: StepEdge,
  fork_step_edge: ForkStepEdge,
};

export default edgeTypes;
